import { ReactNode } from 'react';
import { Footer2018 } from './footer';
import { use2018Assets } from './shared';

type SubpageKey =
  | 'agenda'
  | 'awards'
  | 'winners'
  | 'advisory'
  | 'judges'
  | 'judges_criteria'
  | 'sponsors'
  | 'highlights'
  | 'contact_us';

export const SubpageLayout2018 = ({
  lang,
  title,
  page,
  children,
}: {
  lang: 'en' | 'zh';
  title: string;
  page: SubpageKey;
  children: ReactNode;
}) => {
  const isZh = lang === 'zh';
  use2018Assets({ lang, title, variant: 'awards' });

  const base = isZh ? '/2018/zh' : '/2018';
  const otherBase = isZh ? '/2018' : '/2018/zh';

  return (
    <>
      <div id="Lightbox">
        <div className="spinner">
          <div className="dot1" />
          <div className="dot2" />
        </div>
      </div>

      <div className="menu_container" id="menu_container">
        <div className="topnav" id="myTopnav">
          <a href={base} className="topnav_logo" id="topnav_logo">
            <img src="/2018/images/head_logo_2.png" alt="" />
          </a>
          <div className="tab_container" id="tab_container">
            <a href={base} id="tab_home">
              {isZh ? '主頁' : 'HOME'}
            </a>
            <a href={`${base}/agenda`}>{isZh ? '峰會' : 'SUMMIT'}</a>
            <a href={`${base}/awards`} className="tab_awards">
              {isZh ? '獎項' : 'AWARDS'}
            </a>
            <a href={`${base}/winners`} className="tab_winners">
              {isZh ? '得獎名單' : 'WINNERS'}
            </a>
            <a href={`${base}/advisory`}>{isZh ? '諮詢委員會' : 'ADVISORY BOARD'}</a>
            <div className="dropdown">
              <a href="#" className="dropbtn">
                {isZh ? '評審委員會' : 'JUDGING'}
              </a>
              <div className="dropdown-content">
                <a href={`${base}/judges`}>{isZh ? '評審' : 'JUDGES'}</a>
                <a href={`${base}/judges_criteria`}>{isZh ? '評審準則' : 'JUDGING CRITERIA'}</a>
              </div>
            </div>
            <a href={`${base}/sponsors`}>{isZh ? '贊助' : 'SPONSORS'}</a>
            <a href={`${base}/highlights`}>{isZh ? '花絮' : 'HIGHLIGHTS'}</a>
            <div className="language container" id="language">
              <div className="lang_icon">
                <img src="/2018/images/lang_icon.png" alt="" />
              </div>
              <a
                href={`${otherBase}/${page}`.replace('/index', '').replace(/\/$/, '')}
                className="language_ch"
                style={{
                  fontFamily: isZh ? 'Poppins' : 'Microsoft JhengHei',
                  padding: 0,
                  paddingLeft: 6,
                  textAlign: 'center',
                  color: '#004fad',
                  position: 'absolute',
                  borderBottom: 0,
                  display: 'inline-block',
                }}
              >
                {isZh ? 'En' : '中'}
              </a>
            </div>
          </div>
          <a
            id="click"
            href="#"
            style={{ fontSize: 15 }}
            className="icon"
            onClick={(e) => {
              e.preventDefault();
              (window as any).myFunction?.();
            }}
          >
            <i className="fa fa-bars" />
          </a>
        </div>
      </div>

      <div className="wrapper">
        <div className="head_banner">
          <div className="KV">
            <div className="KV_envir a">
              <img src="/2018/images/awards_KV.jpg" alt="" />
            </div>
          </div>
        </div>
        <div className="left_head_banner">
          <div className="small_wrapper">
            <a href={base} className="head_logo">
              <img src="/2018/images/head_logo.png" alt="" />
            </a>
          </div>
          <div className="head_logo_mobile">
            <img src="/2018/images/head_logo_3.png" alt="" />
          </div>
          <div className="small_wrapper_mobile" />
        </div>
      </div>

   
      <div className="wave_bg_pattern" />

      {children}

      <Footer2018 lang={lang} />
    </>
  );
};

export const SubpageIntro2018 = ({
  heading,
  intro,
}: {
  heading: string;
  intro?: string;
}) => (
  <div className="awards_para_introduction para_introduction">
    <h1>{heading}</h1>
    {intro ? (
      <div className="center_introduction">
        <p className="p1">{intro}</p>
      </div>
    ) : null}
  </div>
);

